import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { UserService } from 'src/app/private/_shared/services/user.service';

@Injectable()
export class MarketplaceAdminGuard implements CanActivate {
  constructor(
    private readonly user: UserService,
    private readonly router: Router,
  ) { }

  async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    if (this.user.userDocument$.getValue()) {
        if (this.user.marketplaceAdmin) {
            console.log('MarketplaceAdminGuard:: user authorized')
            return true
        }
        else {
            console.log('MarketplaceAdminGuard:: user not authorized, redirecting to marketplace')
            this.router.navigate(['/marketplace'])
            return false
        }
    }
    else {
        console.log('MarketplaceAdminGuard:: user document not loaded yet, redirecting to loading page')
        this.router.navigate(['loading'])
        return false
    }
  }
}

